module.exports = __webpack_public_path__ + "static/3d-tour-0d9ac60a10715625ab9c2368e11aaea1.png";